"use strict";

var dragula = require("../_dragula/dragula");
var atoa = require("atoa");

function reactDragula() {
  return dragula.apply(this, atoa(arguments)).on("cloned", cloned);

  function cloned(clone) {
    console.log(clone);
    rm(clone);
    atoa(clone.getElementsByTagName("*")).forEach(rm);
  }

  function rm(el) {
    el.removeAttribute("data-reactid");
  }
}

module.exports = reactDragula;



// WEBPACK FOOTER //
// ./_rc-react-dragula/react-dragula.js